import React from 'react'
import './Loader.scss'


export default () => <div className="lds-ripple"><div/><div/></div>